import React from 'react';

const ToursDetails = () => {
  return (
    <div id="App"></div>
  );
};

export default ToursDetails;
